import { useEffect } from 'react'

import { Roles } from 'src/Constants/enums'
import { curatorRegistrationCompleteEvent } from 'src/Helpers/TagManager'
import { useAppSelector } from 'src/Hooks/redux'
import {
  getUser,
  getUserRoleSelector,
} from 'src/Redux/auth-process/userSlice/selectors'
import {
  clearPendingSpotifyCuratorAuth,
  hasPendingSpotifyCuratorAuth,
} from 'src/Utils/pendingSpotifyCuratorAuth'
import { hasSentSignup, markSignupSent } from 'src/Utils/sentSignupUsers'

import { isNewAccount } from './useGoogleSignupEvent'

export const useSpotifyCuratorSignupEvent = (): null => {
  const { id, createdAt } = useAppSelector(getUser)
  const role = useAppSelector(getUserRoleSelector)

  useEffect(() => {
    if (!id || !createdAt || role !== Roles.curator) {
      return
    }

    if (!hasPendingSpotifyCuratorAuth()) {
      return
    }

    clearPendingSpotifyCuratorAuth()

    const userId = String(id)

    if (
      !isNewAccount(createdAt) ||
      hasSentSignup('spotify_curator_signup', userId)
    ) {
      return
    }

    markSignupSent('spotify_curator_signup', userId)
    curatorRegistrationCompleteEvent({ userId: Number(id) })
  }, [id, createdAt, role])

  return null
}
